import { apiSlice } from "../app/api/apiSlice";

export const MetaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    metaApi: builder.mutation({
      query: (payload) => ({
        url: "meta-capi",
        method: "POST",
        keepalive: true,
        body: { ...payload },
      }),
    }),
    getOrderId: builder.query({
      query: (id) => ({ url: `meta-order-id?quizId=${id}` }),
    }),
    getOrderBySession: builder.query({
      query: (sessionId) => ({ url: `order/by-session?session_id=${sessionId}` }),
    }),
  }),
});

export const {
  useMetaApiMutation,
  useGetOrderIdQuery,
  useLazyGetOrderIdQuery,
  useLazyGetOrderBySessionQuery,
} = MetaApiSlice;
